module.exports = __webpack_public_path__ + "img/mitten_showring.5fd86fac.jpg";